<template>
  <v-switch
    hide-details
    v-model="value"
    :loading="loading"
    inset
    label="Délégué·e Syndical·e ? "
    @change="envoyerChangerEstDelegueSyndical"
  />
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    estDelegueSyndical: {
      type: Boolean,
      required: true,
    },
    employeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      value: this.estDelegueSyndical,
      loading: false,
    }
  },
  methods: {
    ...mapActions({
      changerEstDelegueSyndical: 'employe/changerEstDelegueSyndical',
    }),
    envoyerChangerEstDelegueSyndical(estDelegueSyndical) {
      this.loading = true
      this.changerEstDelegueSyndical({
        _employeId: this.employeId,
        estDelegueSyndical: estDelegueSyndical,
      }).then((res) => {
        this.loading = false
        this.value = res.delegueSyndical
      })
    },
  },
}
</script>
